import { css } from 'styled-components';
import { VariantOfType } from '../../variants';

export const CssDividerDefault = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;

  &:before,
  &:after {
    content: '';
    display: block;
    flex: 1 0 auto;
    height: 1px;
    margin-top: 1px;
    background-color: var(--color-neutral-200);
  }

  .title {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0 0.75em;
    font-weight: 700;
    font-size: 0.8rem;
    text-transform: uppercase;
    color: var(--color-neutral-600);
    z-index: 1;
    white-space: nowrap;
  }
`;

export const dividerVariants = {
  default: CssDividerDefault,
};

export type IDividerVariants = VariantOfType<typeof dividerVariants>;
